/**
 * src/lib/constants/priority.js
 *
 * Canonical mapping between the raw DB priority values and the P1/P2/P3
 * display form used by the FocusView filter, TaskCard priority pill, and
 * anywhere else the CEO sees priority badges.
 *
 * DB contract (migration 065_task_priority.sql):
 *   tasks.priority text NOT NULL DEFAULT 'medium'
 *   CHECK (priority IN ('high', 'medium', 'low'))
 *
 * Frontend display contract:
 *   P1 = high (red)
 *   P2 = medium (amber)
 *   P3 = low (green)
 *
 * This helper is the single source of truth for that translation. Any
 * reader/writer of task.priority on the frontend goes through here so we
 * never have the 2026-04-08 "P1 filter matches zero tasks because DB
 * stores 'high' and filter compares 'P1'" bug again.
 */

const DB_TO_P = {
  high:   'P1',
  medium: 'P2',
  low:    'P3',
};

const P_TO_DB = {
  P1: 'high',
  P2: 'medium',
  P3: 'low',
};

/**
 * Normalize any priority input (DB form, P-form, legacy, nullish) to the
 * canonical P1/P2/P3 display form. Unknown / missing values default to 'P2'
 * so sorting and filtering have a sensible neutral bucket.
 */
export function priorityToP(input) {
  if (!input) return 'P2';
  const s = String(input).trim();
  if (s === 'P1' || s === 'P2' || s === 'P3') return s;
  const lower = s.toLowerCase();
  return DB_TO_P[lower] || 'P2';
}

/**
 * Convert the P-form back to the DB form for writes.
 */
export function pToPriority(p) {
  return P_TO_DB[p] || 'medium';
}
